/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import MasterService from '../../../../services/master'
import UserService from '../../../../services/user'
import CompanyService from '../../../../services/company'
import JobService from '../../../../services/job'
import useServices from '../../../../utils/hooks/useServices'
import {Link} from 'react-router-dom'
import {dateFormat} from 'thesis-and-dissertations/helpers/helper'

const heads = [
  {
    name: '',
    label: 'Judul',
  },
  {
    name: '',
    label: 'Tanggal dibuat',
  },
]

const status = [
  {
    name: 'Menunggu Konfirmasi',
  },
  {
    name: 'Aktif',
  },
  {
    name: 'Ditolak',
  },
  {
    name: 'Non Aktif',
  },
]

const StatusComponent = (statusNumber: any) => {
  return (
    <button
      style={{
        background: '#E8FEF3',
        borderRadius: '10px',
        color: '#50CD89',
        padding: '0.5rem',
        width: '87px',
        border: 'none',
      }}
      className='shadow-none'
    >
      {status[statusNumber].name}
    </button>
  )
}

// sort_order:
// desc
// page:
// 1
// sort_field:
// created_at
// per_page:
// 10
// status[]:
// 3
// status[]:
// 4
// is_company:
// true

const DashboardPage: FC = () => {
  const [card] = useServices(UserService.dashboardAdmin)
  const [job] = useServices(JobService.getJobHash, {
    per_page: 10,
    sort_field: 'created_at',
    sort_order: 'desc',
    status: [0],
  })
  const [company] = useServices(MasterService.getCompany, {
    per_page: 10,
    sort_field: 'created_at',
    sort_order: 'desc',
    status: [3],
    is_company: true,
  })
  const [alumni] = useServices(
    MasterService.getAlumniHash,
    {
      per_page: 10,
      sort_field: 'created_at',
      sort_order: 'desc',
      is_alumni: true,
      status: [6],
    },
    []
  )
  const [role, setRole] = useState<string>('')

  useEffect(() => {
    setRole(localStorage.getItem('keyRole') ?? '')
  }, [])

  return (
    <>
      <div className='row'>
        <div className='col-md-4'>
          <div className='card-custom'>
            <p className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2 mb-4'>
              {card?.data?.company_registered ?? 0}
            </p>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Perusahaan Aktif</span>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='card-custom'>
            <p className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2 mb-4'>
              {card?.data?.alumni_registered ?? 0}
            </p>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Alumni Aktif</span>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='card-custom'>
            <p className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2 mb-4'>
              {card?.data?.company_jobs ?? 0}
            </p>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Lowongan Aktif</span>
          </div>
        </div>
      </div>

      <br />
      <div className='row'>
        <div className='col-md-12 mb-8'>
          <div className='card-custom'>
            <div className='row'>
              <div className='col-md-6'>
                <h6>Lowongan Menunggu Approval</h6>
              </div>
              {/* <div className='col-md-6 text-end'>
                <Link to={'/verification-jobs'} className='link-primary'>
                  Lihat Semua
                </Link>
              </div> */}
            </div>
            <Table responsive='xs mt-4'>
              <thead>
                <tr>
                  <th>#</th>
                  {heads.map((item, index) => (
                    <th key={index}>{item.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {job?.data?.data.map((item: any, key: any) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item?.company_jobs_title}</td>
                      <td>{new Date(item?.created_at).toLocaleString()}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
        </div>

        {role != 'BPK' && (
          <div className='col-md-6 mb-8'>
            <div className='card-custom'>
              <div className='row'>
                <div className='col-md-6'>
                  <h6>Alumni Menunggu Approval</h6>
                </div>
                {/* <div className='col-md-6 text-end'>
                  <Link to={'/verification-user'} className='link-primary'>
                    Lihat Semua
                  </Link>
                </div> */}
              </div>
              <Table responsive='xs mt-4'>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Alumni</th>
                    <th>Tanggal Daftar</th>
                  </tr>
                </thead>
                <tbody>
                  {alumni?.data?.data.map((item: any, key: any) => {
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>{item?.fullname}</td>
                        <td>{dateFormat(item?.updated_at)}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        )}

        <div className='col-md-6 mb-8'>
          <div className='card-custom'>
            <div className='row'>
              <div className='col-md-6'>
                <h6>Perusahaan Menunggu Approval</h6>
              </div>
              {/* <div className='col-md-6 text-end'>
                <Link to={'/verification-company'} className='link-primary'>
                  Lihat Semua
                </Link>
              </div> */}
            </div>
            <Table responsive='xs mt-4'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Perusahaan</th>
                  <th>Tanggal Daftar</th>
                </tr>
              </thead>
              <tbody>
                {company?.data?.data.map((item: any, key: any) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item?.companies_name}</td>
                      <td>{dateFormat(item?.created_at)}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  )
}

const Dashboard: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Dashboard
      </PageTitle>
      <DashboardPage />
    </>
  )
}

export default Dashboard
